module.exports = __webpack_public_path__ + "assets/img/41b00259866636168354a72a32308c90.svg";